import {useCallback, useRef, useState} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {useRegistrationWizardExposure} from "./use_registration_wizard_exposure";

const EXPOSURE_ELEMENT_ID = "registration-wizard-exposure";
const EXPOSURE_VISIBILITY_THRESHOLD = 0.5;

interface IUseRegistrationWizardExposureOnViewParams {
    /** The element the arms of the experiment render differently is rendered for the user */
    isEnabled: boolean;
}

/** Reports the registration wizard exposure once the returned element has been in the viewport */
export const useRegistrationWizardExposureOnView = <TElement extends Element>({isEnabled}: IUseRegistrationWizardExposureOnViewParams) => {
    const elementRef = useRef<TElement | null>(null);
    const [wasViewed, setWasViewed] = useState(false);

    const onElementVisible = useCallback((_id: string, entry: IntersectionObserverEntry) => {
        if (entry.intersectionRatio >= EXPOSURE_VISIBILITY_THRESHOLD) {
            setWasViewed(true);
        }
    }, []);

    useElementWasVisible({
        ids: [],
        elementRefs: [{id: EXPOSURE_ELEMENT_ID, ref: elementRef}],
        onElementVisible,
        once: false,
        threshold: EXPOSURE_VISIBILITY_THRESHOLD,
        disabled: !isEnabled || wasViewed
    });

    useRegistrationWizardExposure({isExposed: isEnabled && wasViewed});

    return elementRef;
};
import {useCallback, useRef, useState} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {useRegistrationWizardExposure} from "./use_registration_wizard_exposure";

const EXPOSURE_ELEMENT_ID = "registration-wizard-exposure";
const EXPOSURE_VISIBILITY_THRESHOLD = 0.5;

interface IUseRegistrationWizardExposureOnViewParams {
    /** The element the arms of the experiment render differently is rendered for the user */
    isEnabled: boolean;
}

/** Reports the registration wizard exposure once the returned element has been in the viewport */
export const useRegistrationWizardExposureOnView = <TElement extends Element>({isEnabled}: IUseRegistrationWizardExposureOnViewParams) => {
    const elementRef = useRef<TElement | null>(null);
    const [wasViewed, setWasViewed] = useState(false);

    const onElementVisible = useCallback((_id: string, entry: IntersectionObserverEntry) => {
        if (entry.intersectionRatio >= EXPOSURE_VISIBILITY_THRESHOLD) {
            setWasViewed(true);
        }
    }, []);

    useElementWasVisible({
        ids: [],
        elementRefs: [{id: EXPOSURE_ELEMENT_ID, ref: elementRef}],
        onElementVisible,
        once: false,
        threshold: EXPOSURE_VISIBILITY_THRESHOLD,
        disabled: !isEnabled || wasViewed
    });

    useRegistrationWizardExposure({isExposed: isEnabled && wasViewed});

    return elementRef;
};
